import React from 'react';
import {
	Button as MButton,
	Dialog, DialogActions, DialogContent, DialogTitle,
	Grid,
	IconButton, LinearProgress,
	Paper,
	Table, TableBody, TableCell,
	TableContainer, TableHead, TablePagination, TableRow,
	TextField,
	Toolbar,
	Tooltip,
	Typography
} from "@material-ui/core";

import {AddCircle, Delete, RemoveCircle, Visibility} from "@material-ui/icons";

const RelatedProducts = ({props, relatedProducts}) => {
	return (
		<div>
			<Paper className="p-3">
				<Grid container spacing={1}>
					<Grid item container xs={12}>
						<TextField
							type="search"
							label="Search products..."
							className="w-100"
							variant="outlined"
							onChange={relatedProducts.handleSearchProduct}
							inputRef={relatedProducts.searchRef}
						/>
					</Grid>
					<Grid item container xs={12}>
						<div className="w-100">
							<Paper>
								{relatedProducts.selectedProducts.length > 0 ? (
									<Toolbar style={{backgroundColor: "rgb(63, 81, 181, 0.2)"}}>
										<Typography color="primary" variant="subtitle1" component="div" style={{flex: "1 1 100%"}}>
											{relatedProducts.selectedProducts.length} selected
										</Typography>
										<Tooltip title={relatedProducts.isView ? "Quit View" : "View"}>
											<IconButton color={relatedProducts.isView ? "primary" : "default"}
											            onClick={relatedProducts.handleToggleViewProducts}>
												<Visibility/>
											</IconButton>
										</Tooltip>
										<Tooltip title="Deselect">
											<IconButton color="secondary" onClick={relatedProducts.handleRemoveAllSelectedProduct}>
												<Delete/>
											</IconButton>
										</Tooltip>
									</Toolbar>
								) : null}
								<TableContainer style={{position: "relative"}}>
									{relatedProducts.fetching && (
										<div
											style={{
												display: "block",
												position: "absolute",
												inset: 0,
												background: "rgb(166 166 166 / 20%)",
											}}
										/>
									)}
									<Table stickyHeader>
										<TableHead>
											<TableRow>
												<TableCell component="th">Image</TableCell>
												<TableCell component="th">ID</TableCell>
												<TableCell component="th">SKU</TableCell>
												<TableCell component="th">Name</TableCell>
												<TableCell component="th">Action</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{!relatedProducts.isView ? (
												relatedProducts.products?.length && relatedProducts.search ? (
													relatedProducts.products?.map((product) => {
														return (
															<TableRow key={product.item_id} hover>
																<TableCell>
																	<img
																		alt="product"
																		loading="lazy"
																		src={product.default_image_url}
																		style={{
																			display: "block",
																			height: 50,
																			width: 50,
																			aspectRatio: "1/1",
																			objectFit: "contain",
																			cursor: "pointer",
																		}}
																		onError={(e) => {
																			e.target.onerror = null;
																			e.target.src = require("../../../assets/images/delishop-favicons.png");
																		}}
																		onClick={() => relatedProducts.handleOpenDialogImgOpen(product)}
																	/>
																</TableCell>
																<TableCell>{product.item_id}</TableCell>
																<TableCell>{product.product_code}</TableCell>
																<TableCell>{product.name}</TableCell>
																<TableCell>
																	<Tooltip arrow
																	         title={relatedProducts.isAdded(product.item_id) ? "Deselect" : "Select"}>
																		<IconButton onClick={() => relatedProducts.handleSelectProducts(product)}>
																			{relatedProducts.isAdded(product.item_id) ? (
																				<RemoveCircle color="secondary"/>
																			) : (
																				<AddCircle color="primary"/>
																			)}
																		</IconButton>
																	</Tooltip>
																</TableCell>
															</TableRow>
														);
													})
												) : (
													<TableRow>
														<TableCell colSpan={5} align="center">
															No Data
														</TableCell>
													</TableRow>
												)
											) : relatedProducts.selectedProducts?.length ? (
												relatedProducts.selectedProducts?.map((product) => {
													return (
														<TableRow key={product.item_id} hover>
															<TableCell>
																<img
																	alt="product"
																	src={product.default_image_url}
																	style={{
																		display: "block",
																		height: 50,
																		width: 50,
																		aspectRatio: "1/1",
																		objectFit: "contain",
																		cursor: "pointer",
																	}}
																	onClick={() => relatedProducts.handleOpenDialogImgOpen(product)}
																/>
															</TableCell>
															<TableCell>{product.item_id}</TableCell>
															<TableCell>{product.product_code}</TableCell>
															<TableCell>{product.name}</TableCell>
															<TableCell>
																<Tooltip arrow title="Remove">
																	<IconButton onClick={() => relatedProducts.handleRemoveRelatedProduct(product)}>
																		<RemoveCircle color="secondary"/>
																	</IconButton>
																</Tooltip>
															</TableCell>
														</TableRow>
													);
												})
											) : (
												<TableRow>
													<TableCell colSpan={5} align="center">
														No Data
													</TableCell>
												</TableRow>
											)}
										</TableBody>
									</Table>
								</TableContainer>
								<div
									style={{
										display: "block",
										width: "100%",
										height: "5px",
									}}
								>
									{relatedProducts.fetching && <LinearProgress variant="query"/>}
								</div>
								{!relatedProducts.isView && relatedProducts.search ? (
									<TablePagination
										component="div"
										page={relatedProducts.page}
										rowsPerPage={relatedProducts.rowsPerPage}
										rowsPerPageOptions={[5, 10, 25, 50]}
										count={relatedProducts.productTotal}
										onPageChange={relatedProducts.handleChangePage}
										onRowsPerPageChange={relatedProducts.handleChangeRowPerPage}
									/>
								) : null}
							</Paper>
						</div>
					</Grid>
				</Grid>
			</Paper>

			<Dialog
				open={relatedProducts.dialogImgOpen}
				maxWidth="xs"
				onClose={() => relatedProducts.handleOpenDialogImgOpen({})}
			>
				<DialogTitle>{relatedProducts.selectedItem?.name}</DialogTitle>
				<DialogContent dividers>
					<div className="d-flex justify-content-center align-items-center">
						<img
							style={{
								display: "inline",
								width: 300,
								height: "auto",
								objectFit: "contain",
								aspectRatio: "1/1",
							}}
							src={relatedProducts.selectedItem?.default_image_url}
							alt={relatedProducts.selectedItem?.name}
							onError={(e) => {
								e.target.onerror = null;
								e.target.src = require("../../../assets/images/delishop-favicons.png");
							}}
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<MButton
						size="small"
						variant="contained"
						onClick={() => relatedProducts.handleOpenDialogImgOpen({})}
					>
						Close
					</MButton>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default RelatedProducts;